import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=642c1070&"
import script from "./Booking.vue?vue&type=script&lang=js&"
export * from "./Booking.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/user_booking.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports